import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import { selectLayoutConfig } from 'store/config/selectors';
import { dismissErrorDialog } from 'store/errorDialog/actions';
import { getErrorDialogState } from 'store/errorDialog/selectors';

import { androidScreenMarginBottom } from 'utils/responsiveness';

import Dialog from 'components/Dialog';
import { textColorStyles } from 'components/Text/styles';

export default function GenericErrorDialog() {
    const {
        error: { title, description, code },
        isVisible,
    } = useSelector(getErrorDialogState);
    const dispatch = useDispatch();
    const { primary } = useSelector(selectLayoutConfig);
    const { t } = useTranslation();

    const dismissError = useCallback(() => {
        dispatch(dismissErrorDialog());
    }, [dispatch]);

    return (
        <Dialog
            visible={isVisible}
            title={title || ''}
            description={description}
            errorCode={code}
            actionButtonTitle={LANGUAGE_KEYS.OK_BUTTON}
            actionButtonAccessibilityLabel={t(LANGUAGE_KEYS.OK_BUTTON)}
            actionButtonOnPress={dismissError}
            actionButtonFillColor={primary}
            actionButtonTextStyle={textColorStyles.black}
            style={{ marginBottom: androidScreenMarginBottom }}
        />
    );
}
